export const RQ_GET_DELIVERY_CHARGES = {
  url: 'api/deliveryCharges/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_UPDATE_DELIVERY_CHARGES = {
  url: 'api/update/deliveryCharges/<%= id %>',
  method: 'PUT',
  auth:true,
};

export const  RQ_ADD_DELIVERY_CHARGES = {
  url:'api/register/deliveryCharges',
  method: 'POST',
  auth: true,
};
